import { render, staticRenderFns } from "./RidaIntisharPerMunicipality.vue?vue&type=template&id=3dbb3b3c&scoped=true&"
import script from "./RidaIntisharPerMunicipality.vue?vue&type=script&lang=js&"
export * from "./RidaIntisharPerMunicipality.vue?vue&type=script&lang=js&"
import style0 from "./RidaIntisharPerMunicipality.vue?vue&type=style&index=0&id=3dbb3b3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb3b3c",
  null
  
)

export default component.exports